import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/notclicked.png'
import _imports_1 from '../assets/images/clicked.png'
import _imports_2 from '../assets/images/wakeup.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "search-input-group" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 4,
  class: "operate"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_10 = { style: {"height":"100px","line-height":"50px","border-top":"1px solid #eaeaea","border-bottom":"1px solid #eaeaea"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"20px"},
  src: _imports_2,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("operater")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("unattended")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_LoadingPage, {
        isLoading: _ctx.isLoading,
        tip: _ctx.t('awakening')
      }, null, 8, ["isLoading", "tip"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_input, {
          style: {"width":"15%"},
          value: _ctx.carList.keyWord,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.carList.keyWord) = $event)),
          placeholder: _ctx.t('supportvinsearch')
        }, null, 8, ["value", "placeholder"]),
        _createVNode(_component_a_button, {
          class: "searchBtn",
          onClick: _ctx.selectChange
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_select, {
          placeholder: _ctx.t('whole'),
          value: _ctx.optionValue,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.optionValue) = $event)),
          style: {"width":"10%","margin":"0 20px"},
          onChange: _ctx.selectChange,
          allowClear: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carTypeList, (item) => {
              return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["placeholder", "value", "onChange"]),
        _createVNode(_component_a_button, {
          style: {"margin":"0 20px"},
          onClick: _ctx.SelectIsLogin
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("onlinevehicles")) + "：" + _toDisplayString(_ctx.online_num), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, { onClick: _ctx.SelectHasFault }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("faultyvehicle")) + "：" + _toDisplayString(_ctx.fault_vehicle_num), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        pagination: false,
        scroll: { y: _ctx.maxHeight, x: 2200 },
        onChange: _ctx.onChange
      }, {
        bodyCell: _withCtx(({ column, record, index }) => [
          (column.title === _ctx.t('serialnumber'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(index + 1), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.title === _ctx.t('presence'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (record.sort_field === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t("online")), 1))
                  : _createCommentVNode("", true),
                (record.sort_field === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.t("dormancy")), 1))
                  : _createCommentVNode("", true),
                (record.sort_field === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.t("offline")), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.title === _ctx.t('vehiclestatus'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_ctx.getCarStatusType(record.status, _ctx.t)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.title === _ctx.t('faultstatus'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(record.fault_status === true ? _ctx.t("yes") : _ctx.t("deny")), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.title === _ctx.t('operate'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, {
                          key: "0",
                          disabled: 
                      record.sort_field == '2' || record.sort_field == '3'
                    ,
                          onClick: ($event: any) => (_ctx.toVehicleControl(record.vin, record.status))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("entrycontrol")), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]),
                        _createVNode(_component_a_menu_divider),
                        _createVNode(_component_a_menu_item, {
                          key: "1",
                          disabled: !record.wake_button_enable,
                          onClick: ($event: any) => (_ctx.handleOk(record.vin))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("wakeup")), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "ant-dropdown-link",
                      onClick: ($event: any) => (_ctx.checkItem(record.vin))
                    }, [
                      (record.vin !== _ctx.checkedId)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                    ], 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "scroll", "onChange"]),
      _createVNode(_component_a_pagination, {
        class: "pagination",
        "show-size-changer": "",
        "show-quick-jumper": "",
        "show-total": (total) => `${_ctx.t('intotal')} ${total}${_ctx.t('article')}`,
        current: _ctx.carList.page,
        "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.carList.page) = $event)),
        pageSize: _ctx.carList.size,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.carList.size) = $event)),
        total: _ctx.carList.total,
        size: "small",
        onChange: _ctx.handlePaginationChange
      }, null, 8, ["show-total", "current", "pageSize", "total", "onChange"])
    ]),
    _createVNode(_component_a_modal, {
      open: _ctx.open,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.open) = $event)),
      title: _ctx.t('tips'),
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("cancellation")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _ctx.toAwaken
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("determine")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.t("confirmwanttowakevehicle")), 1)
        ])
      ]),
      _: 1
    }, 8, ["open", "title"])
  ], 64))
}